import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import classNames from 'classnames';
import React from 'react';

const DIRECTION_RIGHT = 'right';
const DIRECTION_LEFT = 'left';
const DIRECTION_DOWN = 'down';
const DIRECTION_UP = 'up';
const SIZE_BIG = 'big';
const SIZE_SMALL = 'small';

const rootSx = (theme) => ({
  stroke: theme.tokens.matterColor,
  fill: theme.tokens.matterColor,
});

const IconArrowHead = ({
  className = null,
  rootClassName = null,
  direction,
  size = SIZE_SMALL,
  sx: sxProp = null,
}) => {
  const classes = classNames(rootClassName, className);
  const baseSx = rootClassName ? undefined : rootSx;
  const sx = [baseSx, sxProp].filter(Boolean);
  const iconFontSize = size === SIZE_BIG ? 'large' : 'small';

  switch (direction) {
    case DIRECTION_RIGHT:
      return <ChevronRightIcon className={classes} fontSize={iconFontSize} sx={sx} />;
    case DIRECTION_LEFT:
      return <ChevronLeftIcon className={classes} fontSize={iconFontSize} sx={sx} />;
    case DIRECTION_DOWN:
      return <KeyboardArrowDownIcon className={classes} fontSize={iconFontSize} sx={sx} />;
    case DIRECTION_UP:
      return <KeyboardArrowUpIcon className={classes} fontSize={iconFontSize} sx={sx} />;
    default:
      return null;
  }
};

export default IconArrowHead;
